import { render, staticRenderFns } from "./NotificationsBody.vue?vue&type=template&id=6b9284c5&scoped=true&"
import script from "./NotificationsBody.vue?vue&type=script&lang=js&"
export * from "./NotificationsBody.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsBody.vue?vue&type=style&index=0&id=6b9284c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9284c5",
  null
  
)

export default component.exports